import React, { FunctionComponent } from 'react';

import { I18nUtils } from 'app/utils/i18n-utils';
import { i18n } from 'app/i18n';
import { connectedUpgradeUnitImageProps } from 'app/resources/images';

import { ConnectionInstructions, ConnectionInstructionsProps } from './connection-instructions';
import { Description } from './description';

type Props = Omit<ConnectionInstructionsProps, 'description' | 'connectionInstructions' | 'image'>;

export const UpgradeUnitInstructions: FunctionComponent<Props> = (props) => (
    <ConnectionInstructions
        {...props}
        description={I18nUtils.richMessage(i18n.page.productDetails.upgradeUnitInstructions.description, {
            text: (
                <Description component="span" $highlighted={true}>
                    {i18n.page.productDetails.upgradeUnitInstructions.descriptionNotice}
                </Description>
            ),
        })}
        image={connectedUpgradeUnitImageProps}
        connectionInstructions={i18n.page.productDetails.upgradeUnitInstructions.connectedItems}
    />
);
